import { bootstrap } from 'src/bootstrap';

bootstrap()
  .catch(() => {
    import('src/helpers/renderErrorScreen').then((m) => m.renderErrorScreen());
  })
  .finally(() => {
    const loader = document.getElementById('loader');
    loader?.classList.add('completed');
  });
